import axios from "axios";
import * as https from "https";

const configs = {
  baseURL: `${process.env.BASE_URL}/api`,
  headers: {
    "Content-Type": "application/json",
  },
  httpsAgent: new https.Agent({
    rejectUnauthorized: false,
  }),
};

const api = axios.create(configs);

export default api;
